<template>
    <v-card :height="height">
        <v-tabs
        v-model="doctab"
        :background-color="proMode ? 'grey darken-3' : 'grey lighten-3'"
        :color="proMode ? 'yellow' : 'black'"
        grow
        height="30"
        >
        <v-tab
            v-for="doc in docs"
            :key="doc.dockey"
            @click="getURL(doc.dockey)"
        >
            {{ doc.name }}
        </v-tab>
        </v-tabs>

        <v-tabs-items v-model="doctab">
            <v-tab-item
                v-for="doc in docs"
                :key="doc.dockey"
            >
                <iframe 
                    v-if="doc.filetype == 'pdf'"
                    :src="activeURL" 
                    width="100%" 
                    :height="iHeight" 
                    :style="'min-height:' + iHeight + ' !important'"
                />
                <v-scroll-y-transition>
                    <v-sheet
                        color="grey darken-2"
                        height="300"
                        v-show="showHistory"
                    >
                        <v-data-table
                            dense
                            :headers="historyHeaders"
                            :items="history"
                            :items-per-page="100"
                            height="300"
                            dark
                            fixed-header
                            hide-default-footer
                        >
                            <template
                                v-slot:item.Size="{ item }"
                            >
                                {{ formatBytes(item.Size) }}
                            </template>
                        </v-data-table>
                    </v-sheet>
                </v-scroll-y-transition>
                <v-btn
                    color="grey darken-4"
                    dark
                    bottom
                    fixed
                    left
                    x-small
                    fab
                    @click="getHistory"
                    elevation="2"
                >
                    <v-icon>mdi-history</v-icon>
                </v-btn>
            </v-tab-item>
        </v-tabs-items>
        
        <!-- <v-bottom-sheet v-model="sheet">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="green"
                    dark
                    absolute
                    bottom
                    left
                    x-small
                    fab
                    v-bind="attrs"
                    v-on="on"
                    @click="getHistory"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
           <v-data-table
                dense
                :headers="historyHeaders"
                :items="history"
                :items-per-page="5"
            >
                <template
                    v-slot:item.Size="{ item }"
                >
                    {{ formatBytes(item.Size) }}
                </template>
            </v-data-table>
        </v-bottom-sheet> -->
    </v-card>
</template>

<script>
export default {
  name: 'EnhancedDocViewer',
  props: {
    docs:Array,
    height:String,
    client:String,
    facility:String,
    proMode:Boolean,
  },
  components: {
  },
  data () {
    return {
        history:[],
        showHistory:false,
        doctab:null,
        sheet:false,
        iHeight:"",
        activeURL:"",
        activeDocKey:"",
        historyHeaders:[
            { text: 'Latest', value: 'IsLatest' },
            { text: 'Modified', value: 'LastModified' },
            { text: 'Size', value: 'Size' },
        ]
    }
  },
  computed: {
  },
  mounted () {
      this.getURL(this.docs[0].dockey);
      this.iHeight = this.heightFix(this.height,30);
  },
  watch: {
  },
  methods: {
    heightFix(h,s){
        if(h.includes("px")){
            let v = Number(h.split("p")[0]);
            return (v-s) + "px";
        }else if(h.includes("vh")){
             let v = Number(h.split("v")[0]);
            return (v-(s/10)) + "vh";
        }else{
            return v;
        }
    },
    formatBytes(a,b=2){if(0===a)return"0 Bytes";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return parseFloat((a/Math.pow(1024,d)).toFixed(c))+" "+["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]},
    async getHistory(){
        console.log("GET HISTORY");
        this.showHistory = !this.showHistory;
        if(this.showHistory){
            this.iHeight = this.heightFix(this.height,330);
        }else{
            this.iHeight = this.heightFix(this.height,30);
        }
    },
    async getURL(dockey){
        console.log("GET URL");
        this.activeDocKey = dockey;
        let res = await this.getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/prod/docs/" + this.client + "/" + this.facility +"/" + dockey);
        this.activeURL = res.url;
        this.history = await this.getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/prod/docs/" + this.client + "/" + this.facility +"/" + this.activeDocKey + "/history");
    },
    async getData(url = "") {
        // Default options are marked with *
        const response = await fetch(url, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": "application/json",
            "Authorization": this.$store.getters.jwt
        },
        //redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }
  }
}
</script>

